/*
 * @Author: 陈小英 13880788935@163.com
 * @Date: 2024-04-18 10:47:50
 * @LastEditors: 陈小英 13880788935@163.com
 * @LastEditTime: 2024-04-22 11:32:48
 * @FilePath: \operation-center\src\views\websiteAdmin\antireptileSet\components\frequencySet\business\frequencySet.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import { parseTime } from '@/utils/util'

export const columns = [
  {
    title: '序号',
    dataIndex: 'id',
    width: 80,
    align: 'center',
  },
  {
    title: 'IP地址',
    dataIndex: 'ip_address',
    width: 160,
    align: 'left',
  },
  {
    title: 'IP归属地',
    dataIndex: 'ip_address_belong_to',
    width: 160,
    align: 'left',
    scopedSlots: { customRender: 'ip_address_belong_to' },
  },
  {
    title: '开放平台',
    dataIndex: 'project',
    align: 'left',
    width: 260,
    scopedSlots: { customRender: 'project' },
  },
  {
    title: '有效期',
    dataIndex: 'expiration_end_date',
    align: 'left',
    width: 180,
    scopedSlots: { customRender: 'expiration_end_date' },
  },
  {
    title: '备注',
    dataIndex: 'remark',
    width: 160,
    align: 'left',
  },
  {
    title: '相关人员',
    dataIndex: 'user_id',
    align: 'left',
    width: 150,
    scopedSlots: { customRender: 'user_id' },
  },
  {
    title: '相关时间',
    dataIndex: 'created_at',
    align: 'left',
    width: 180,
    scopedSlots: { customRender: 'create_at' },
  },
  {
    title: '状态',
    dataIndex: 'state',
    align: 'left',
    width: 120,
    scopedSlots: { customRender: 'state' },
  },
  {
    title: '操作',
    align: 'center',
    width: 100,
    // fixed: 'right',
    dataIndex: 'operator',
    scopedSlots: { customRender: 'operator' },
  },
]

export const searchForm = {
  ip_address: '',
  ip_address_belong_to: '',
  expiration_start_date: '',
  expiration_end_date: '',
  created_name: '',
  updated_name: '',
  created_at: [],
  updated_at: [],
  state: undefined,
}
